import { HeadingVariant, Row, Space } from "@stenajs-webui/core";
import { Property } from "csstype";
import * as React from "react";
import { ReactNode } from "react";
import { PaddedHeading } from "../padded-heading/PaddedHeading";

interface Props {
  title?: string;
  contentRight?: ReactNode;
  contentLeft?: ReactNode;
  infoRow?: ReactNode;
  variant?: HeadingVariant;
  whiteSpace?: Property.WhiteSpace;
  space?: number;
}

export const PageSubHeader: React.FC<Props> = ({
  title,
  contentRight,
  contentLeft,
  infoRow,
  variant = "h4",
  whiteSpace,
}) => {
  return (
    <>
      <Row alignItems={"center"} justifyContent={"space-between"}>
        <Row alignItems={"center"} height={"62px"}>
          {contentLeft}
          <PaddedHeading variant={variant} whiteSpace={whiteSpace}>
            {title}
          </PaddedHeading>
        </Row>
        <Row alignItems={"center"}>{contentRight}</Row>
      </Row>
      {infoRow}
    </>
  );
};
